import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./footer.scss"
import logo from "../../../media/img/logo_daroma_vertical.png"

const Footer = () => {
  const { t } = useTranslation();

  const openCookieSettings = (e) => {
    e.preventDefault();
    if (typeof window.daromaOpenCookies === "function") {
      window.daromaOpenCookies();
    }
  };

  return (
    <footer className="footer">
      <div className="footer-columns">
        {/* Columna 1: Logo */}
        <div className="footer-column container-logo-footer">
          <img src={logo} alt="Logo" className="footer-logo" />
        </div>

        {/* Columna 2: Daroma */}
        <div className="footer-column">
          <h4 className="footer-title">{t("footer.daromaTitle")}</h4>
          <ul className="footer-links">
            <li><a href="/">{t("footer.links.home")}</a></li>
            <li><a href="/AboutUsPage">{t("footer.links.about")}</a></li>
            <li><a href="/Productos/products">{t("footer.links.products")}</a></li>
            <li><a href="/Productos/services">{t("footer.links.services")}</a></li>
          </ul>
        </div>

        {/* Columna 3: Legal */}
        <div className="footer-column">
          <h4 className="footer-title">{t("footer.legalTitle")}</h4>
          <ul className="footer-links">
            <li><a href="/Contacto">{t("footer.links.contact")}</a></li>
            <li><Link to="/legal#aviso-legal">{t("footer.links.legalNotice")}</Link></li>
            <li><Link to="/legal#privacidad">{t("footer.links.privacy")}</Link></li>
            <li><Link to="/legal#cookies">{t("footer.links.cookies")}</Link></li>
            <li>
              <a href="#cookies-settings" onClick={openCookieSettings}>
                {t("footer.links.manageCookies")}
              </a>
            </li>
          </ul>
        </div>

        {/* Columna 4: Connect */}
        <div className="footer-column">
          <h4 className="footer-title">{t("footer.connectTitle")}</h4>
          <ul className="footer-links">
            <li>
              <a href="https://www.linkedin.com/company/daroma-innovation-s-l" target="_blank" rel="noopener noreferrer">
                LinkedIn
              </a>
            </li>
            <li><a href="#twitter">X / Twitter</a></li>
            <li><a href="#instagram">Instagram</a></li>
          </ul>
        </div>
      </div>

      {/* Texto centrado debajo de las columnas */}
      <div className="footer-bottom">
        <p>{t("footer.copyright")}</p>
      </div>
    </footer>
  );
};

export default Footer;
